function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import myEcharts from '@/components/scEcharts/chart-widget.vue';
import { queryChartData } from '@/api/chart';
export default {
  name: 'progressbar-widget',
  components: {
    myEcharts: myEcharts
  },
  props: {
    field: Object,
    designer: Object
  },
  data: function data() {
    return {
      cutField: '',
      donutChartOption: {
        title: {
          text: '30%',
          x: 'center',
          y: 'center',
          textStyle: {
            fontWeight: 'normal',
            color: '#29EEF3',
            fontSize: '15'
          }
        },
        legend: {
          show: false,
          right: 5,
          top: 5
        },
        grid: {
          containLabel: true
        },
        tooltip: {
          formatter: function formatter(params) {
            return params.name + '：' + params.percent + ' %';
          }
        },
        series: [{
          name: 'circle',
          type: 'pie',
          radius: ['30%', '50%'],
          itemStyle: {
            label: {
              show: false
            },
            labelLine: {
              show: false
            }
          },
          data: [{
            value: 30,
            name: '占比',
            itemStyle: {
              color: {
                colorStops: [{
                  offset: 0,
                  color: '#4FADFD'
                }, {
                  offset: 1,
                  color: '#28E8FA'
                }]
              },
              label: {
                show: false
              },
              labelLine: {
                show: false
              }
            },
            label: {
              show: false
            }
          }, {
            name: '剩余',
            value: 70,
            itemStyle: {
              color: '#E1E8EE'
            },
            label: {
              show: false
            }
          }]
        }]
      },
      wavesChart: {
        title: {
          show: false,
          text: '',
          x: '48%',
          y: '50%',
          z: 10,
          textAlign: 'center',
          textStyle: {
            color: '#ffffff',
            fontSize: 15,
            fontWeight: 500
          }
        },
        grid: {
          containLabel: true
        },
        legend: {
          show: false,
          right: 5,
          top: 5
        },
        series: [{
          type: 'liquidFill',
          radius: '90%',
          center: ['50%', '50%'],
          itemStyle: {
            opacity: 0.95,
            shadowColor: 'rgba(0, 0, 0, 0)'
          },
          amplitude: 10,
          data: [0.1, 0.1, 0.1],
          color: [{
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0,
              color: 'rgba(24, 144, 255, 0.5)'
            }, {
              offset: 1,
              color: '#79BEFF'
            }],
            globalCoord: false
          }],
          backgroundStyle: {
            borderWidth: 1,
            color: '#fff'
          },
          label: {
            position: ['50%', '75%'],
            formatter: '10%',
            fontSize: 24,
            color: '#59AFFF'
          },
          outline: {
            borderDistance: 0,
            itemStyle: {
              borderWidth: 1,
              borderColor: '#59AFFF'
            }
          }
        }]
      },
      myOption: {},
      percentage: 0,
      metePercentage: 0,
      progressText: '',
      loading: false,
      isShowEmpty: false,
      cutCompleted: 0,
      numericUnits: '',
      metricsConf: {}
    };
  },
  watch: {
    field: {
      handler: function handler(newVal) {
        this.cutField = newVal;
        this.initOption();
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {
    this.cutField = this.field;
    this.initOption();
  },
  methods: {
    initOption: function initOption() {
      var _this$cutField = this.cutField,
        options = _this$cutField.options,
        type = _this$cutField.type;
      if (options) {
        var setDimensional = options.setDimensional;
        var metrics = setDimensional.metrics;
        if (metrics.length < 1) {
          this.myOption.isNoData = true;
          return;
        }
        this.metricsConf = metrics[0];
        this.numericUnits = metrics[0].numericUnits == '无' ? '' : metrics[0].numericUnits;
        this.getChartData(options, type);
        this.myOption.isNoData = false;
      } else {
        this.myOption.isNoData = true;
      }
    },
    getChartData: function getChartData(options, type) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, chartStyle, setDimensional, setChartConf, targetValue, metrics, maxNum, cutNum, point;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.prev = 1;
              _context.next = 4;
              return queryChartData(options, type);
            case 4:
              res = _context.sent;
              if (res && res.status === 200) {
                chartStyle = options.chartStyle, setDimensional = options.setDimensional, setChartConf = options.setChartConf;
                targetValue = setDimensional.targetValue, metrics = setDimensional.metrics;
                _this.myOption = chartStyle == 1 ? _this.donutChartOption : _this.wavesChart;
                maxNum = targetValue || 1;
                cutNum = res.data.value;
                _this.cutCompleted = cutNum;
                point = Math.round(cutNum / maxNum * 100);
                _this.percentage = point > 100 ? 100 : point;
                _this.metePercentage = point;
                _this.progressText = setChartConf.numShow ? metrics[0].alias : null;
                // 图例是否显示
                _this.myOption.legend.show = setChartConf.chartShow;
                if (chartStyle == 1) {
                  _this.myOption.title.text = "".concat(point, "%");
                  _this.myOption.series[0].data[0].value = cutNum;
                  _this.myOption.series[0].data[0].name = metrics[0].alias + '：' + _this.getPreviewNum(cutNum) + (_this.numericUnits ? _this.numericUnits : '');
                  _this.myOption.series[0].data[1].value = maxNum - cutNum;
                  _this.myOption.series[0].data[1].name = '剩余：' + _this.getPreviewNum(maxNum - cutNum) + (_this.numericUnits ? _this.numericUnits : '');
                  _this.myOption.series[0].data[0].label.show = setChartConf.numShow;
                  _this.myOption.series[0].data[1].label.show = setChartConf.numShow;
                } else {
                  _this.myOption.series[0].data = [point / 100, point / 100, point / 100];
                  _this.myOption.series[0].label.formatter = point + '%';
                  // this.myOption.title.text =
                  //   metrics[0].alias +
                  //   '（已完成：' +
                  //   this.getPreviewNum(this.cutCompleted) +
                  //   (this.numericUnits ? this.numericUnits : '') +
                  //   '） '
                  _this.myOption.title.show = setChartConf.numShow;
                  _this.myOption.series[0].label.show = setChartConf.numShow;
                }
                _this.isShowEmpty = false;
              } else {
                _this.isShowEmpty = true;
              }
              _context.next = 12;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error('Error fetching chart data:', _context.t0);
              _this.isShowEmpty = true;
            case 12:
              _this.loading = false;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    formatText: function formatText() {
      return this.progressText ? this.progressText + '（已完成：' + this.getPreviewNum(this.cutCompleted) + (this.numericUnits ? this.numericUnits : '') + '） ' + this.metePercentage + '%' : '';
    },
    getPreviewNum: function getPreviewNum(val) {
      var _this$metricsConf = this.metricsConf,
        thousandsSeparator = _this$metricsConf.thousandsSeparator,
        showDecimalPlaces = _this$metricsConf.showDecimalPlaces,
        decimalPlaces = _this$metricsConf.decimalPlaces;
      var newVal = val;
      if (showDecimalPlaces) {
        newVal = Number(newVal).toFixed(decimalPlaces);
      }
      if (thousandsSeparator) {
        newVal = this.numberToCurrencyNo(newVal);
      }
      return newVal;
    },
    numberToCurrencyNo: function numberToCurrencyNo(value) {
      if (!value) return 0;
      // 获取整数部分
      var intPart = Math.trunc(value);
      // 整数部分处理，增加,
      var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      // 预定义小数部分
      var floatPart = '';
      // 将数值截取为小数部分和整数部分
      var valueArray = value.toString().split('.');
      if (valueArray.length === 2) {
        // 有小数部分
        floatPart = valueArray[1].toString(); // 取得小数部分
        return intPartFormat + '.' + floatPart;
      }
      return intPartFormat + floatPart;
    },
    setSelected: function setSelected() {
      this.designer.setSelected(this.field);
    }
  }
};